import { httpService } from '@/services/HttpService';

class AuthService {
  login(email: string, password: string, remember_me: boolean): Promise<any> {
    return httpService.post(
      'sign_in',
      { email, password, remember_me, locale: (window as any).VueGlobal.$i18n.locale },
      {},
      { isErrorSuppressed: true, isAuthErrorSuppressed: true }
    );
  }
  resetPasswordEmail(email: string): Promise<any> {
    return httpService.post('reset_password', { email, locale: (window as any).VueGlobal.$i18n.locale });
  }
  validateResetPassToken(token: string): Promise<any> {
    return httpService.get(`reset_password/${token}`);
  }
  resetPassToken(token: string, password: string): Promise<any> {
    return httpService.put(`reset_password/${token}`, { password });
  }
  logout(token: string) {
    return httpService.delete('sign_out', { token });
  }
}

export const authService = new AuthService();
